import { identity } from "~/tools/identity";
import type { GetImpulseFormInput, GetImpulseFormOutput } from "~/tools/impulse-form";

import type { DashboardWidgetThreshold } from "../../../../common/dashboard-spec";
import { WidgetThresholdsStep } from "../../../widget-form/thresholds/form-state";
import type { FormProcessor } from "../../_form-processor";

type Spec = DashboardWidgetThreshold;
type StepFormState = WidgetThresholdsStep;
type Input = GetImpulseFormInput<StepFormState>;

function specToInput({ color, value }: Spec): Input {
	return {
		color: color ?? WidgetThresholdsStep.default.color,
		value: value?.toString() ?? WidgetThresholdsStep.default.value,
	};
}

function verboseOutputToSpec({ color, value }: GetImpulseFormOutput<StepFormState>): Spec {
	return {
		color: color ?? WidgetThresholdsStep.fallback.color,
		value: value ?? WidgetThresholdsStep.fallback.value,
	};
}

const StepFormState = {
	init: WidgetThresholdsStep.init,
	specToInput,
	outputToSpec: identity,
	verboseOutputToSpec,
} satisfies FormProcessor<Spec, StepFormState, Input>;

export { StepFormState };
